import * as React from 'react';
import { SchoolEvent, SchoolEventTeamDataPlayer } from 'Src/models/event';
import { StudentEventTeamPlayerPosition } from './TeamPlayerPosition';
import {
  isEventStatusFinished,
  isMultipartyEvent,
  isShowIndividualScoreForTeam
} from '../../../../../../../helpers/event/event';
import {
  convertPointsToStringWithoutDelimeter,
  getIndividualScoreByStudent
} from '../../../../../../../helpers/event/schoolEventViewHelper';
import { StudentEventTeamPlayerSubOrCaptain } from './TeamPlayerSubOrCaptain';
import { convertPointsCricket, isCricket } from '../../../../../../../helpers/sport/cricket';
import { EventParticipantIdentity } from 'Src/components/EventParticipantIdentity/EventParticipantIdentity';

interface Props {
  players: SchoolEventTeamDataPlayer[];
  event: SchoolEvent;
  currentUserId: string;
  currentUserAvatar?: string;
}

export function StudentEventTeamPlayers(props: Props) {
  const { players, event, currentUserId, currentUserAvatar } = props;
  const sortedPlayers = [...players].sort((a, b) => {
    const currentDifference =
      Number(String(b.userId) === String(currentUserId)) - Number(String(a.userId) === String(currentUserId));
    if (currentDifference !== 0) return currentDifference;
    return `${a.lastName || ''} ${a.firstName || ''}`.localeCompare(`${b.lastName || ''} ${b.firstName || ''}`);
  });

  const isShowIndividualScore = isShowIndividualScoreForTeam(event, players);

  const rows = sortedPlayers.map((player, playerIndex) => {
    const { userId, permissionId } = player;
    const isEventFinished = isEventStatusFinished(event);
    const playerPoints = getIndividualScoreByStudent(event, userId, permissionId);

    let playerPointsStr;

    if (isCricket(event) && !isMultipartyEvent(event)) {
      const { runs, wickets } = convertPointsCricket(playerPoints);
      playerPointsStr = `${runs} / ${wickets}`;
    } else {
      playerPointsStr = convertPointsToStringWithoutDelimeter(event, playerPoints);
    }

    const isShowPoints = (isEventFinished && isShowIndividualScore) || Boolean(playerPoints);
    const isCurrentUser = String(userId) === String(currentUserId);

    return (
      <tr key={`school_players_${playerIndex}`} className={isCurrentUser ? 'eventParticipantRow--owned' : ''}>
        <td className="eventParticipantRow__number">
          <span>{playerIndex + 1}</span>
        </td>

        <td style={{ width: '28%' }}>
          <EventParticipantIdentity
            firstName={player.firstName}
            lastName={player.lastName}
            isOwned={isCurrentUser}
            avatar={currentUserAvatar}
            ownedLabel="You"
          />
        </td>

        <td style={{ width: '15%' }}>
          <span className="ml-2 eventParticipantLastName">{player.lastName}</span>
        </td>

        <td style={{ width: '15%' }}>
          {isShowPoints && <span className={'ml-3 font-weight-bold'}>{`${playerPointsStr} `}</span>}
        </td>

        <td style={{ width: '24%' }}>
          <span className={'ePlayersPosition'}>
            <StudentEventTeamPlayerPosition player={player} event={event} />
          </span>
        </td>

        <td style={{ width: '13%' }}>
          <span className={'ePlayersSubOrCaptain'}>
            <StudentEventTeamPlayerSubOrCaptain player={player} event={event} />
          </span>
        </td>
      </tr>
    );
  });
  return (
    <table className={'w-100 eventParticipantRoster'}>
      <tbody>{rows}</tbody>
    </table>
  );
}
